import { createContext, ReactNode, useContext, useMemo, useState } from 'react';

interface MediaTableContextType {
  filteredRowCount: number | null;
  setFilteredRowCount: (count: number | null) => void;
  filteredDuration: number | null;
  setFilteredDuration: (duration: number | null) => void;
  filteredSize: number | null;
  setFilteredSize: (size: number | null) => void;
}

const MediaTableContext = createContext<MediaTableContextType | null>(null);

export const useMediaTable = () => {
  const context = useContext(MediaTableContext);
  if (!context) {
    throw new Error('useMediaTable must be used within a MediaTableProvider');
  }
  return context;
};

interface MediaTableProviderProps {
  children: ReactNode;
}

export const MediaTableProvider = ({ children }: MediaTableProviderProps) => {
  const [filteredRowCount, setFilteredRowCount] = useState<number | null>(null);
  const [filteredDuration, setFilteredDuration] = useState<number | null>(null);
  const [filteredSize, setFilteredSize] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      filteredRowCount,
      setFilteredRowCount,
      filteredDuration,
      setFilteredDuration,
      filteredSize,
      setFilteredSize,
    }),
    [
      filteredRowCount,
      setFilteredRowCount,
      filteredDuration,
      setFilteredDuration,
      filteredSize,
      setFilteredSize,
    ],
  );

  return <MediaTableContext.Provider value={value}>{children}</MediaTableContext.Provider>;
};
